import { Dropdown, Menu, Typography, Avatar, Space } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import styles from './index.module.less';
import { getLoggedInUser } from 'utilities/helpers';
import LocalStorage from 'utilities/localStorage';
import { useDispatch } from 'react-redux';
import { useMsal } from '@azure/msal-react';
import { logout } from 'pages/login/redux/slice';
import ColorHash from 'color-hash';
const { Text } = Typography;

const colorHash = new ColorHash({ lightness: 0.7 });

const UserMenu = () => {
  const dispatch = useDispatch();
  const { instance } = useMsal();

  const handleLogout = () => {
    instance?.logoutRedirect({
      account: LocalStorage.homeAccountId,
      postLogoutRedirectUri: '/',
      mainWindowRedirectUri: '/',
      onRedirectNavigate: () => {
        dispatch(logout());
        return true;
      }
    });
  };

  const user = getLoggedInUser();
  const menu = (
    <Menu style={{ width: '130px' }}>
      <Menu.Item key="2" icon={<LogoutOutlined />} onClick={handleLogout}>
        <Text>Logout</Text>
      </Menu.Item>
    </Menu>
  );
  const initials = `${user?.user_details?.first_name?.[0] || ''}${
    user?.user_details?.last_name?.[0] || ''
  }`;

  const backgroundColor = colorHash.hex(initials);

  return (
    <>
      <Dropdown className={`${styles.icon_color}`} overlay={menu}>
        <Space className={`${styles.gr_logo_header}`}>
          <Avatar style={{ backgroundColor }}>{initials}</Avatar>

          <span style={{ color: 'black' }} className="hidden md:inline">
            {user?.user_details?.first_name} {user?.user_details?.last_name}
          </span>
        </Space>
      </Dropdown>
    </>
  );
};

export default UserMenu;
